import { useCallback, useEffect, useRef } from "react";
import { createRequestFormServicePreselection } from "../utils/requestFormServicePreselection";

/**
 * Pre-select request-form services/templates after async catalog + vendor capability data loads.
 * Skips overwriting once the user manually changes the selection.
 */
export default function useRequestFormServicePreselection({
  mode = "vqq",
  provider,
  providerId,
  urlTemplateId = null,
  urlTemplateName = null,
  questionnairesLoading = false,
  questionnaires = [],
  templateOptions = [],
  v2Options = [],
  rfisLoading = false,
  isLoadingCapabilities = false,
  resolvedProvider = null,
  vendorCategoryNames = [],
  selectedServices = [],
  setServiceCategories,
}) {
  const userEditedRef = useRef(false);
  const lastAppliedProviderRef = useRef(null);
  const urlTemplateAppliedRef = useRef(false);

  useEffect(() => {
    createRequestFormServicePreselection({
      mode,
      provider,
      providerId,
      urlTemplateId,
      urlTemplateName,
      questionnairesLoading,
      questionnaires,
      templateOptions,
      v2Options,
      rfisLoading,
      isLoadingCapabilities,
      resolvedProvider,
      vendorCategoryNames,
      selectedServices,
      setServiceCategories,
      userEditedRef,
      lastAppliedProviderRef,
      urlTemplateAppliedRef,
    });
  }, [
    mode,
    provider,
    providerId,
    urlTemplateId,
    urlTemplateName,
    questionnairesLoading,
    questionnaires,
    templateOptions,
    v2Options,
    rfisLoading,
    isLoadingCapabilities,
    resolvedProvider,
    vendorCategoryNames,
    selectedServices,
    setServiceCategories,
  ]);

  const setServicesWithUserTracking = useCallback(
    (next) => {
      userEditedRef.current = true;
      setServiceCategories(next);
    },
    [setServiceCategories],
  );

  return { setServicesWithUserTracking };
}
